import { Box, Breadcrumbs, Button, Checkbox, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { categoryNameOptions, useCommonStyles } from '../../utils';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import ErrorHandler from '../../lib/errorHandler';
import CommonTextField from '../Common/CommonTextField';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import { getItemByLotNumber, getItemForUpdateProduction, getLotNumbers, getProductionLotNumber, moveItemToProduction, updateProduction } from '../../Redux/Actions/PurchaseEntry';
import CommonPagination from '../Common/CommonPagination';
import ErrorMessage from '../Common/ErrorMessage';
import dayjs from 'dayjs';
import CommonDatePicker from '../Common/CommonDatePicker';
import { isCompleteDate } from '../../lib/standardDateFormat';

const AddProduction = ({ setIsOpenAddUpdateProduction, _getProduction, setSearchValue, data, setData, isEditMode, setIsEditMode }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [lotNumberPage, setLotNumberPage] = useState(1);
    const [lotNumberTotalCount, setLotNumberTotalCount] = useState();
    const [lotNumberList, setLotNumberList] = useState([]);
    const [lotNumberOptions, setLotNumberOptions] = useState([]);
    const [searchLotNumber, setSearchLotNumber] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [aboveSelectedItems, setAboveSelectedItems] = useState([]);

    const [errors, setErrors] = useState({})
    const [page, setPage] = useState(1);
    const [reelByLotIdListData, setReelByLotIdListData] = useState();
    const [selectedFinalList, setSelectedFinalList] = useState([]);
    const [rowsSaved, setRowsSaved] = useState([]);

    // ============== Handler ==============

    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdateProduction(false); setIsEditMode(false); setData({}); _getProduction({}); setSearchValue("") }}>
            Production List
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`Add Production`}
        </Typography>,
    ];

    const tabelHeader = ["Type", "Item No.", "GSM / MIC", "Lot No.", "Reel No.", "Size", "Weight"]
    let PerPage = 10
    const handleChangePage = (e, p) => {
        setPage(p);
    };
    const handleChange = (name, value) => {
        if (name == "lotNumber") {
            setData({ ...data, [name]: value })
            // setSelectedRows([])
            setPage(1)
            setReelByLotIdListData([])
        } else if (name == "category") {
            setData({ ...data, [name]: value, "lotNumber": "" })
            setLotNumberList([])
            setReelByLotIdListData([])
        } else {
            setData({ ...data, [name]: value })
        }
    }

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            // Add current page's rows to selectedRows, avoiding duplicates
            setSelectedRows((prev) => {
                const newSelection = reelByLotIdListData?.response?.filter(
                    (row) => !prev.some((item) => item._id === row._id)
                );
                return [...prev, ...newSelection];
            });
        } else {
            // Remove only the rows from the current page
            setSelectedRows((prev) =>
                prev.filter((item) => !reelByLotIdListData?.response?.some((row) => row._id === item._id))
            );
        }
    };

    // console.log("selectedRows", selectedRows)

    const handleAddRow = () => {
        setRowsSaved([...selectedRows])
    }

    const handleRowSelect = (row) => {
        setSelectedRows((prev) => {
            const isSelected = prev.find((item) => item._id === row._id);
            return isSelected ? prev.filter((item) => item._id !== row._id) : [...prev, row];
        });
        setSelectedFinalList([...selectedFinalList, row])
    };
    const isAllSelected =
        reelByLotIdListData?.response?.length > 0 &&
        reelByLotIdListData?.response?.every((row) =>
            selectedRows.some((item) => item._id === row._id)
        );
    // ============== Get Lot Number API ==============
    const _getLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : lotNumberPage,
            "search": searchText ? searchText : "",
            category: data?.category?.id,
        };
        response = await dispatch(getProductionLotNumber(body));
        { (lotNumberList?.length !== lotNumberTotalCount) && setLotNumberPage(lotNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText ? searchText : "");
            setLotNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != lotNumberList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setLotNumberList([...lotNumberList, ...response?.payload?.data?.response]);
                } else {
                    setLotNumberList([])
                }
            }
        }
    };

    const handleChangeInputForLotNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            category: data?.category?.id,
        };
        response = await dispatch(getProductionLotNumber(body));
        setLotNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchLotNumber(searchText);
            setLotNumberList(response?.payload?.data?.response);
        }
    };

    // ============= get Perticular Lot Numbers API =============
    const _getPerticularLotNumbers = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            "lotNumber": data?.lotNumber?.lotNumber,
            "limit": PerPage,
            "page": page,
            category: +data?.category?.id,
        }
        const fn = isEditMode ? getItemForUpdateProduction : getItemByLotNumber
        response = await dispatch(fn(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                if (isEditMode) {
                    const selectedItems = response?.payload?.data?.response?.filter((ele) => ele?.status == "In Production")
                    setAboveSelectedItems(selectedItems)
                    setSelectedRows(selectedItems)
                }
                setReelByLotIdListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // =============== Validations ===============
    const validation = () => {
        let flag = true;
        let errors = {};

        if (!data?.lotNumber) {
            errors.lotNumber = "Please Select Lot Number.";
            flag = false;
        }
        else if (selectedRows?.length == 0) {
            flag = false;
            setSnackBar("error", "please select at least one item.")

        }
        if (data?.date) {
            if (!isCompleteDate(data?.date)) {
                flag = false;
                setSnackBar("error", "Please select valid date")
            }
        }

        setErrors(errors);
        return flag;
    };
    // ============= get Perticular Lot Numbers API =============
    const _moveItemToProduction = async () => {
        if (validation()) {
            setFullPageLoader(true);
            let response;
            // const finalSelectedRows = selectedRows?.map((ele) => {
            //     return {
            //         "type": ele?.type,
            //         "itemNo": ele?.externalItemNo,
            //         "GSMMIC": ele?.GSMMIC,
            //         "lotNumber": ele?.lotNumber,
            //         "reelNo": ele?.reelNumber,
            //         "size": ele?.size,
            //         "weight": ele?.weight,
            //         // "itemName": ele?.ItemData?.purchaseOrder?.[0]?.itemName
            //         "itemName": ele?.itemName
            //     }
            // })
            const notInProductionItems = selectedRows?.filter((ele) => ele?.status == "Not In Production")
            const selectedIds = selectedRows?.map((row) => row?._id);
            const aboveSelectedItemForRemove = aboveSelectedItems?.filter(
                (ele) => !selectedIds?.includes(ele?._id)
            );
            const finalNotInProductionItems = notInProductionItems?.map((ele) => {
                return {
                    "type": ele?.type,
                    "itemNo": ele?.externalItemNo,
                    "GSMMIC": ele?.GSMMIC,
                    "lotNumber": ele?.lotNumber,
                    "reelNo": ele?.reelNumber,
                    "size": ele?.size,
                    "weight": ele?.weight,
                    // "itemName": ele?.ItemData?.purchaseOrder?.[0]?.itemName
                    "itemName": ele?.itemName
                }
            })
            const finalAboveSelectedItemForRemove = aboveSelectedItemForRemove?.map((ele) => {
                return {
                    "type": ele?.type,
                    "itemNo": ele?.externalItemNo,
                    "GSMMIC": ele?.GSMMIC,
                    "lotNumber": ele?.lotNumber,
                    "reelNo": ele?.reelNumber,
                    "size": ele?.size,
                    "weight": ele?.weight,
                    // "itemName": ele?.ItemData?.purchaseOrder?.[0]?.itemName
                    "itemName": ele?.itemName
                }
            })
            // let body = {
            //     "products": [
            //         {
            //             "lotNumber": data?.lotNumber?.lotNumber,
            //             "quantity": data?.quantity,
            //             "date": data.date ? dayjs(data.date).format("YYYY-MM-DD") : null,
            //             "items": finalSelectedRows,
            //             "category": +data?.category?.id,
            //         }
            //     ]
            // }

            const mappedItems = selectedRows?.map((ele) => ({
                type: ele?.type,
                itemNo: ele?.externalItemNo,
                GSMMIC: ele?.GSMMIC,
                lotNumber: ele?.lotNumber,
                reelNo: ele?.reelNumber,
                size: ele?.size,
                weight: ele?.weight,
                itemName: ele?.itemName,
                category: ele?.category
            }));

            const itemsByLot = mappedItems.reduce((acc, item) => {
                if (!acc[item.lotNumber]) acc[item.lotNumber] = [];
                acc[item.lotNumber].push(item);
                return acc;
            }, {});

            const products = Object.keys(itemsByLot).map((lot) => {
                const lotItems = itemsByLot[lot];
                return {
                    lotNumber: lot,
                    quantity: lotItems.reduce((sum, item) => sum + (item.weight || 0), 0),
                    date: data.date ? dayjs(data.date).format("YYYY-MM-DD") : null,
                    items: lotItems,
                    category: lotItems[0]?.category ? +lotItems[0].category : null
                };
            });

            let body = {
                "products": products
            }
            let updateBody = {
                "lotNumber": data?.lotNumber?.lotNumber,
                "category": +data?.category?.id,
                "selectedItems": finalNotInProductionItems,
                "deselectedItems": finalAboveSelectedItemForRemove
            }
            const fn = isEditMode ? updateProduction : moveItemToProduction
            const finalBody = isEditMode ? updateBody : body
            response = await dispatch(fn(finalBody));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message);
                    setData({})
                    setSelectedRows([])
                    setIsOpenAddUpdateProduction(false)
                    setIsEditMode(false);
                    _getProduction()
                    setSearchValue("")
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    // ====================== Use Effects ======================
    useEffect(() => {
        if (data?.lotNumber?.lotNumber) {
            _getPerticularLotNumbers();
        }
    }, [data?.lotNumber, page]);

    useEffect(() => {
        if (data?.category) {
            _getLotNumber(1);
        }
    }, [data?.category]);

    useEffect(() => {
        setLotNumberOptions(lotNumberList?.map((e) => e));
    }, [lotNumberList]);

    useEffect(() => {
        if (selectedRows?.length > 0) {
            const hasDecimal = selectedRows.some(row => (row?.weight || 0) % 1 !== 0);
            const totalWeight = selectedRows.reduce((sum, row) => sum + (row?.weight || 0), 0);
            const formattedTotalWeight = hasDecimal ? parseFloat(totalWeight.toFixed(2)) : totalWeight;
            setData({ ...data, quantity: formattedTotalWeight })
        } else {
            setData({ ...data, quantity: 0 })
        }
    }, [selectedRows]);

    return (
        <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`Add Production`}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px" }}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> Production Detail </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="Category"
                                placeholder="Select Category"
                                options={categoryNameOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.category || null}
                                onChange={(e, newValue) => { handleChange("category", newValue) }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label="Lot No."
                                placeholder="Select Lot No."
                                options={lotNumberOptions || []}
                                getOptionLabel={(option) => option?.lotNumber || ""}
                                value={data?.lotNumber || null}
                                onChange={(e, newValue) => handleChange("lotNumber", newValue)}
                                loadData={(lotNumberOptions?.length !== lotNumberTotalCount) ? _getLotNumber : undefined}
                                handleSearch={(e) => handleChangeInputForLotNumber(1, e?.target?.value)}
                                searchValue={searchLotNumber}
                            />
                            <ErrorMessage text={data?.lotNumber ? "" : errors?.lotNumber} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                type="number"
                                label="Quantity"
                                disabled
                                name="quantity"
                                value={data?.quantity || 0}
                                placeholder="Enter The Quantity"
                                onChange={(e) => {
                                    if (+e?.target?.value >= 0) {
                                        handleChange("quantity", e.target.value)
                                    } else {
                                        return;
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonDatePicker
                                label="Date"
                                onChange={(value) => handleChange("date", value)}
                                value={data?.date || null}
                                name="date"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                <StyledTableCell>
                                                    <Checkbox
                                                        defaultChecked={isAllSelected ? true : false}
                                                        checked={isAllSelected ? true : false}
                                                        onChange={reelByLotIdListData?.response?.length === 0 ? () => { } : handleSelectAll}
                                                    />
                                                </StyledTableCell>
                                                {tabelHeader?.map((ele) => {
                                                    return (
                                                        <StyledTableCell>{ele}</StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {reelByLotIdListData?.response?.length > 0 ?
                                                reelByLotIdListData?.response?.map((row, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <StyledTableRow noColor>
                                                                <StyledTableCell>
                                                                    <Checkbox
                                                                        defaultChecked={selectedRows.some((item) => item._id === row._id)}
                                                                        checked={selectedRows.some((item) => item._id === row._id)}
                                                                        onChange={() => handleRowSelect(row)}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    {row?.type}
                                                                </StyledTableCell>
                                                                <StyledTableCell>{row?.externalItemNo || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.GSMMIC || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.lotNumber || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.reelNumber || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.size || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.weight || "NA"}</StyledTableCell>
                                                            </StyledTableRow>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <CommonPagination
                                    totalCount={reelByLotIdListData?.count || 0}
                                    count={Math.ceil(reelByLotIdListData?.count / PerPage)}
                                    itemsPerPage={PerPage}
                                    page={page}
                                    onChange={handleChangePage}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Grid item xs={12} display={"flex"} gap={2}>
                <Button className={classes.saveButton} onClick={() => handleAddRow()}>Add Production</Button>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px" }}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> Selected items Detail </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                <StyledTableCell>
                                                    <Checkbox
                                                        defaultChecked={isAllSelected ? true : false}
                                                        checked={isAllSelected ? true : false}
                                                    // onChange={reelByLotIdListData?.response?.length === 0 ? () => { } : handleSelectAll}
                                                    />
                                                </StyledTableCell>
                                                {tabelHeader?.map((ele) => {
                                                    return (
                                                        <StyledTableCell>{ele}</StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowsSaved?.length > 0 ?
                                                rowsSaved?.map((row, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <StyledTableRow noColor>
                                                                <StyledTableCell>
                                                                    <Checkbox
                                                                        defaultChecked={selectedRows.some((item) => item._id === row._id)}
                                                                        checked={selectedRows.some((item) => item._id === row._id)}
                                                                        onChange={() => handleRowSelect(row)}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    {row?.type}
                                                                </StyledTableCell>
                                                                <StyledTableCell>{row?.externalItemNo || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.GSMMIC || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.lotNumber || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.reelNumber || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.size || "NA"}</StyledTableCell>
                                                                <StyledTableCell>{row?.weight || "NA"}</StyledTableCell>
                                                            </StyledTableRow>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <CommonPagination
                                    totalCount={selectedRows?.count || 0}
                                    count={Math.ceil(selectedRows?.count / PerPage)}
                                    itemsPerPage={PerPage}
                                    page={page}
                                    onChange={handleChangePage}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    

                </Box>
                <Grid item xs={12} display={"flex"} gap={2} sx={{paddingTop:2}}>
                        <Button className={classes.cancelButton} onClick={() => { setIsOpenAddUpdateProduction(false); setIsEditMode(false); setData({}); _getProduction({}) }}>Cancel </Button>
                        <Button className={classes.saveButton} onClick={() =>  _moveItemToProduction()}>Save</Button>
                    </Grid>

            </Grid>
        </Grid>
    )
}

export default AddProduction